import React from "react"
import {Spin} from "antd"
import classes from "./Loading.module.scss"

interface ILoadingProps {
  className?: string
}

export default function Loading({className}: ILoadingProps) {

  const cls = [classes.wrap]

  if (className) cls.push(className)

  return (
    <div className={cls.join(" ")}>
      <Spin/>
    </div>
  )
}